import { BaseAction } from "../../../core/actions/BaseAction";
import { getTranslatedMessage } from "../../../Lib/Utils/i18n";
import { isEmpty } from "../../../Lib/Utils/validationUtil";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IUserResponse, StationType, SubStation } from "../../../Orchestrator/Types/Index";
import { IFavoriteStopActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/FavoriteStopActionParams";
import { showNotification } from "../../../Services/notificationService";
import { savePersonalizeExperienceAction } from "../../LogicActions/MyAccount/PersonalizeExperience/SavePersonalizeExperienceAction";

export class FavoriteStopAction extends BaseAction<void, IFavoriteStopActionParams> {

	override async run(): Promise<void | null> {
		try {
			const { userData, locations, value, locationFor } = this.params!;

			if (!value) {
				return null;
			}

			let railPreferencesPayload: IUserResponse["railPreferences"] = { ...(userData?.railPreferences || {}) };

			let favoriteKey = locationFor === "to" ? "destination" : "origin";
			const isAlreadyFavorite = railPreferencesPayload.favoriteDepartures?.filter(i => favoriteKey in i).find(i => i[favoriteKey as keyof typeof i] === value);

			// Add to favorite
			if (!isAlreadyFavorite) {
				let matchLocation: StationType | SubStation | undefined
				matchLocation = locations.find((loc) => loc.id === value);
				//Check user star to shuttle.
				if (isEmpty(matchLocation)) {
					const allShuttleLocations = locations.flatMap((item) => item?.subStations || []);
					matchLocation = allShuttleLocations.find((loc) => loc.id === value);
				}

				if (!isEmpty(matchLocation) && matchLocation) {
					if (locationFor === "from") {
						railPreferencesPayload.preferredOrigin = matchLocation.id;

						railPreferencesPayload.favoriteDepartures = [
							{ origin: matchLocation.id },
							...(railPreferencesPayload?.favoriteDepartures || [])
						]
						if (!railPreferencesPayload?.multiBooking?.preferredOrigin) {
							railPreferencesPayload.multiBooking = {
								...railPreferencesPayload.multiBooking,
								preferredOrigin: matchLocation?.id,
							};
						}
					} else if (locationFor === "to") {
						railPreferencesPayload.favoriteDepartures = [
							{ destination: matchLocation.id },
							...(railPreferencesPayload?.favoriteDepartures || [])
						]
						railPreferencesPayload.preferredDestination = matchLocation.id;

						if (!railPreferencesPayload?.multiBooking?.preferredDestination) {
							railPreferencesPayload.multiBooking = {
								...railPreferencesPayload.multiBooking,
								preferredDestination: matchLocation?.id,
							};
						}
					}
				}
			} else {
				if (locationFor === "from") {
					// delete railPreferencesPayload.preferredOrigin;
					railPreferencesPayload.preferredOrigin = "";
					railPreferencesPayload.favoriteDepartures = railPreferencesPayload.favoriteDepartures?.filter(i => {
						return !("origin" in i && i.origin === value);
					})
				} else if (locationFor === "to") {
					// delete railPreferencesPayload.preferredDestination;
					railPreferencesPayload.preferredDestination = "";
					railPreferencesPayload.favoriteDepartures = railPreferencesPayload.favoriteDepartures?.filter(i => {
						return !("destination" in i && i.destination === value);
					})
				}
			}

			savePersonalizeExperienceAction.setParams({
				userData: userData,
				railPreferences: railPreferencesPayload,
			});
			await savePersonalizeExperienceAction.execute();

			if (isAlreadyFavorite) {
				showNotification("success", getTranslatedMessage("removedFromYourFavorites"), "");
			} else {
				showNotification("success", getTranslatedMessage("addedToYourFavorites"), "");
			}

		} catch (error) {
			console.error("Error in Favourite StopAction:", error);
		}
	}
}

export const favoriteStopAction = new FavoriteStopAction();
